<app-icd-code-list [codeType]="codeType" title="ICD-8" />
